// A template the add from the catalogue did not turn into an asset, and why (PLAN-073, spec 3.3).
export class AssetFromTemplateSkipped {
  templateId: number;

  // the server's code: ASSET0004 when the template's name is already an asset's name in one of the languages; empty
  // for a failure without one
  code: string;

  reason: string;

  // the register asset with that name, on ASSET0004
  assetId?: number;

  assetName?: string;

  constructor() {
    this.templateId = 0;
    this.code = '';
    this.reason = '';
  }
}

// What an add from the catalogue did: the assets it created, per template, and the templates it skipped.
export class AssetsFromTemplatesResult {
  created: { templateId: number; assetId: number }[];

  skipped: AssetFromTemplateSkipped[];

  constructor() {
    this.created = [];
    this.skipped = [];
  }
}
